import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';
import Hyperlink from '../../shared/components/hyperlink';

import './link.less';

function Link({ type, color, size, to, target, children, onClick, button, className, ...linkProps }) {
    return (
        <span className={`new-link ${type} ${color} ${size}${className ? ' '+className:''}`}>
            <span className="animation-wrapper">
                {button && <button type='button' onClick={onClick}>{children}</button>}
                {!button && <Hyperlink to={to} onClick={onClick} target={target} {...linkProps || {}}>{children}</Hyperlink>}
                {target && <Icon name="link" size={size === 'small' ? 16 : 18} />}
            </span>
            <span className="bar">&nbsp;</span>
        </span>
    );
}

Link.defaultProps = {
    type: 'link',
    color: 'primary',
    size: 'large',
    children: 'link',
    to: null,
    target: false,
    button: false,
};

Link.propTypes = {
    /** different variant styles of links */
    type: PropTypes.oneOf(['link', 'body', 'footer']),
    color: PropTypes.oneOf(['primary', 'dark', 'white']),
    size: PropTypes.oneOf(['small', 'large']),
    children: PropTypes.string,
    /** url */
    to: PropTypes.string,
    /** pop up link */
    target: PropTypes.bool,
    /** use link as button instead of anchor */
    button: PropTypes.bool,
};

export default Link;
